import { render, staticRenderFns } from "./CustomerComplains.vue?vue&type=template&id=7c785515&scoped=true"
import script from "./CustomerComplains.vue?vue&type=script&lang=js"
export * from "./CustomerComplains.vue?vue&type=script&lang=js"
import style0 from "./CustomerComplains.vue?vue&type=style&index=0&id=7c785515&prod&lang=scss&scoped=true"
import style1 from "./CustomerComplains.vue?vue&type=style&index=1&id=7c785515&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c785515",
  null
  
)

export default component.exports